'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes3 = require('./helpers/propTypes');

var _UncontrolledTabs = require('./UncontrolledTabs');

var _UncontrolledTabs2 = _interopRequireDefault(_UncontrolledTabs);

var _count = require('./helpers/count');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};

var Tabs = function (_Component) {
    _inherits(Tabs, _Component);

    function Tabs() {
        _classCallCheck(this, Tabs);

        var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));

        _this.state = Tabs.copyPropsToState(_this.props, {}, _this.props.defaultFocus); // eslint-disable-line react/destructuring-assignment
        _this.componentWillReceiveProps = function (newProps) {
            if (process.env.NODE_ENV !== 'production' && Tabs.inUncontrolledMode(newProps) !== Tabs.inUncontrolledMode(_this.props)) {
                throw new Error('Switching between controlled mode (by using `selectedIndex`) and uncontrolled mode is not supported in `Tabs`.\nFor more information about controlled and uncontrolled mode of react-tabs see the README.');
            }
            // Use a transactional update to prevent race conditions
            // when reading the state in copyPropsToState
            _this.setState(function (state) {
                return Tabs.copyPropsToState(newProps, state);
            });
        };
        _this.handleSelected = function (index, last, event) {
            var onSelect = _this.props.onSelect;
            // Call change event handler

            if (typeof onSelect === 'function') {
                // Check if the change event handler cancels the tab change
                if (onSelect(index, last, event) === false) return;
            }
            var state = {
                // Set focus if the change was triggered from the keyboard
                focus: event.type === 'keydown'
            };
            if (Tabs.inUncontrolledMode(_this.props)) {
                // Update selected index
                state.selectedIndex = index;
            }
            _this.setState(state);
        };
        return _this;
    }
    // Preserve the existing selectedIndex from state
    // If the state has not selectedIndex, default to the defaultIndex or 0


    _createClass(Tabs, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                children = _a.children,
                defaultIndex = _a.defaultIndex,
                defaultFocus = _a.defaultFocus,
                props = __rest(_a, ["children", "defaultIndex", "defaultFocus"]);var _state = this.state,
                focus = _state.focus,
                selectedIndex = _state.selectedIndex;

            props.focus = focus;
            props.onSelect = this.handleSelected;
            if (selectedIndex != null) {
                props.selectedIndex = selectedIndex;
            }
            return _react2.default.createElement(_UncontrolledTabs2.default, Object.assign({}, props), children);
        }
    }], [{
        key: 'copyPropsToState',
        value: function copyPropsToState(props, state) {
            var focus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var newState = {
                focus: focus
            };
            if (Tabs.inUncontrolledMode(props)) {
                var maxTabIndex = (0, _count.getTabsCount)(props.children) - 1;
                var selectedIndex = null;
                if (state.selectedIndex != null) {
                    selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
                } else {
                    selectedIndex = props.defaultIndex || 0;
                }
                newState.selectedIndex = selectedIndex;
            }
            return newState;
        }
    }]);

    return Tabs;
}(_react.Component);

exports.default = Tabs;

Tabs.defaultProps = {
    defaultFocus: false,
    forceRenderTabPanel: false,
    selectedIndex: null,
    defaultIndex: null,
    toAccordion: false
};
Tabs.propTypes = {
    toAccordion: _propTypes2.default.bool,
    children: _propTypes3.childrenPropType.isRequired,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]).isRequired,
    defaultFocus: _propTypes2.default.bool,
    defaultIndex: _propTypes2.default.number,
    disabledTabClassName: _propTypes2.default.string.isRequired,
    forceRenderTabPanel: _propTypes2.default.bool,
    onSelect: _propTypes3.onSelectPropType.isRequired,
    selectedIndex: _propTypes3.selectedIndexPropType,
    selectedTabClassName: _propTypes2.default.string.isRequired,
    selectedTabPanelClassName: _propTypes2.default.string.isRequired
};
Tabs.inUncontrolledMode = function (props) {
    return props.selectedIndex === null;
};
//# sourceMappingURL=Tabs.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Tabs/Tabs.js